import { useFeatureValue } from '@growthbook/growthbook-react';
import { NEW_UI_FLAG } from '@/constants';

export default function useNewUiScope(scope: NewUiScope): boolean {
  const scopes = useFeatureValue<Record<string, boolean>>(
    NEW_UI_FLAG,
    NEW_UI_SCOPES_DEFAULT,
  );
  return scopes[scope] ?? false;
}

export const NEW_UI_SCOPES_DEFAULT = {
  teacherDashboard: false,
  manageKlasses: false,
} satisfies Record<string, boolean>;

export type NewUiScope = keyof typeof NEW_UI_SCOPES_DEFAULT;
